/* global femcare */

femcare.shared.ui = {
    isLoadingOverlayActive: function () {
        return $('.ui-loading-overlay.ui-loading-overlay--applied').length !== 0;
    },

    setLoadingOverlay: function (isLoading) {
        $('.ui-loading-overlay').toggleClass('ui-loading-overlay--applied', isLoading);
    }
}